<div class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4" [dir]="isArabic() ? 'rtl' : 'ltr'">
  <div class="max-h-[90vh] w-full max-w-5xl overflow-y-auto rounded-xl bg-white p-6 shadow-xl">
    <div class="mb-4 flex items-start justify-between">
      <div>
        <h3 class="text-[17px] font-bold text-gray-900">
          {{
            itemType() === 'bundle'
              ? isArabic()
                ? 'تحويل الباقة إلى منتجات'
                : 'Convert Bundle To Products'
              : isArabic()
                ? 'تحويل العرض إلى منتجات'
                : 'Convert Offer To Products'
          }}
        </h3>
        <p class="mt-0.5 text-[13px] text-gray-400">
          {{
            itemType() === 'bundle'
              ? isArabic()
                ? 'أنت على وشك تأكيد المتابعة بالمنتجات المتاحة من هذه الباقة كمنتجات منفصلة.'
                : 'You are about to confirm continuing with the available products from this bundle as separate products.'
              : isArabic()
                ? 'أنت على وشك تأكيد المتابعة بالمنتجات المتاحة من هذا العرض كمنتجات منفصلة.'
                : 'You are about to confirm continuing with the available products from this offer as separate products.'
          }}
        </p>
      </div>
      <button
        (click)="onCancelClick()"
        class="rounded-lg p-1 text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-600">
        <app-cancel-icon />
      </button>
    </div>

    <div class="mt-5 flex flex-col gap-4 md:flex-row md:items-stretch md:gap-6">
      <!-- Current state column -->
      <div class="flex w-full flex-col gap-2 md:w-1/2">
        <span class="text-[13px] font-bold text-gray-700">
          {{
            itemType() === 'bundle'
              ? isArabic()
                ? 'الباقة قبل التحويل'
                : 'Current Bundle'
              : isArabic()
                ? 'العرض قبل التحويل'
                : 'Current Offer'
          }}
        </span>

        @if (itemType() === 'bundle') {
          <app-order-bundle-item
            [productTitle]="productTitleForSource()"
            [products]="$any(orderItem())?.products"
            [totalBusinessPrice]="$any(orderItem())?.totalStorePrice?.toFixed(2)"
            [quantity]="$any(orderItem())?.quantity"
            [profileImageFid]="$any(orderItem())?.bundle?.profileImageFid"
            [totalBusinessPriceBeforeDiscount]="$any(orderItem())?.bundle?.totalPharmacyPriceBeforeDiscount"
            [bundleDiscountType]="$any(orderItem())?.bundle?.discountType"
            [bundleDiscountValue]="$any(orderItem())?.bundle?.discountValue"
            [isPrinted]="isPrinted()"
            [isReadOnly]="true"
            [isPartiallyPackaged]="false"
            [packageState]="packageState()"
            [bundleItemId]="$any(orderItem())?.id" />
        } @else {
          <app-order-offer-item
            [productTitle]="productTitleForSource()"
            [buyQuantity]="$any(orderItem())?.bxGyOffer?.buyQuantity"
            [getQuantity]="$any(orderItem())?.bxGyOffer?.getQuantity"
            [products]="$any(orderItem())?.products"
            [totalBusinessPrice]="$any(orderItem())?.totalStorePrice?.toFixed(2)"
            [quantity]="$any(orderItem())?.quantity"
            [profileImageFid]="
              $any(orderItem())?.bxGyOffer?.profileImageFid ?? $any(orderItem())?.offer?.profileImageFids?.[0]
            "
            [isPrinted]="isPrinted()"
            [isReadOnly]="true"
            [isPartiallyPackaged]="false"
            [packageState]="packageState()"
            [offerItemId]="$any(orderItem())?.id" />
        }
      </div>

      <!-- Direction arrow (→ in LTR / ← in RTL; ↓ on mobile) -->
      <div class="flex items-center justify-center md:self-center md:px-1">
        <svg
          width="26"
          height="26"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="rotate-90 text-gray-400 md:h-8 md:w-8"
          [class.md:rotate-0]="!isArabic()"
          [class.md:rotate-180]="isArabic()">
          <polyline points="9 18 15 12 9 6"></polyline>
        </svg>
      </div>

      <!-- After-conversion column -->
      <div class="flex w-full flex-col gap-2 md:w-1/2">
        <span class="text-[13px] font-bold text-gray-700">
          {{ isArabic() ? 'بعد التحويل' : 'After Conversion' }}
        </span>

        @if (availableProducts().length === 0) {
          <p class="rounded-lg border border-gray-200 bg-gray-50 py-6 text-center text-[13px] text-gray-400">
            {{ isArabic() ? 'لا توجد منتجات متاحة' : 'No available products' }}
          </p>
        } @else {
          @for (row of availableProducts(); track row.product?.id ?? $index) {
            <app-order-product-item
              [productTitle]="productTitle(row)"
              [mfgDate]="rowProduct(row)?.mfgDate"
              [expDate]="rowProduct(row)?.expDate"
              [businessPrice]="productStorePrice(row)"
              [peoplePrice]="productPeoplePrice(row)"
              [totalBusinessPrice]="productTotalPrice(row)"
              [quantity]="row.availableQuantity"
              [batchNumber]="rowProduct(row)?.batchNumber"
              [isPrinted]="isPrinted()"
              [isReadOnly]="true"
              [isPartiallyPackaged]="false" />
          }
        }
      </div>
    </div>

    @if (showWarning()) {
      <div
        class="mt-4 flex items-center gap-2.5 rounded-lg border border-yellow-300 bg-yellow-50 px-4 py-3 text-[13px] font-medium text-yellow-800">
        <svg
          class="shrink-0 text-yellow-600"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round">
          <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
          <line x1="12" y1="9" x2="12" y2="13"></line>
          <line x1="12" y1="17" x2="12.01" y2="17"></line>
        </svg>
        <span>
          {{
            itemType() === 'bundle'
              ? isArabic()
                ? 'سيتم تحويل الباقة الناقصة إلى منتجات عادية. ستُضاف المنتجات المتاحة إلى الطلب بالسعر العادي وسيتم تحديث ملخص الطلب. هل تريد المتابعة؟'
                : 'The incomplete bundle will be converted into normal products. The available products will be added to the order at normal price and the order summary will be updated. Do you want to proceed?'
              : isArabic()
                ? 'سيتم تحويل الأوفر الناقص إلى منتجات عادية. ستُضاف المنتجات المتاحة إلى الطلب بالسعر العادي وسيتم تحديث ملخص الطلب. هل تريد المتابعة؟'
                : 'The incomplete offer will be converted into normal products. The available products will be added to the order at normal price and the order summary will be updated. Do you want to proceed?'
          }}
        </span>
      </div>
    }

    <div class="mt-6 flex items-center justify-end gap-3">
      <button
        (click)="onCancelClick()"
        class="rounded-lg border border-gray-300 px-6 py-2 text-[13px] font-bold text-gray-600 transition-colors hover:bg-gray-50">
        {{ isArabic() ? 'إلغاء' : 'Cancel' }}
      </button>

      <app-submit-button type="primary" (click)="onConfirmClick()">
        {{ isArabic() ? 'تأكيد' : 'Confirm' }}
      </app-submit-button>
    </div>
  </div>
</div>